import publicApiClient from './publicApi';

// Service for SubscriptionPlans API
// Endpoints (backend):
// GET  /api/SubscriptionPlans
// POST /api/SubscriptionPlans
// GET  /api/SubscriptionPlans/{id}
// PUT  /api/SubscriptionPlans/{id}
// DELETE /api/SubscriptionPlans/{id}
// GET  /api/SubscriptionPlans/active
// POST /api/SubscriptionPlans/bulk

const subscriptionPlanService = {
  getAll: async () => {
    const res = await publicApiClient.get('/SubscriptionPlans');
    return res.data;
  },

  create: async (payload) => {
    const res = await publicApiClient.post('/SubscriptionPlans', payload);
    return res.data;
  },

  getById: async (id) => {
    const res = await publicApiClient.get(`/SubscriptionPlans/${id}`);
    return res.data;
  },

  update: async (id, payload) => {
    const res = await publicApiClient.put(`/SubscriptionPlans/${id}`, payload);
    return res.data;
  },

  remove: async (id) => {
    const res = await publicApiClient.delete(`/SubscriptionPlans/${id}`);
    return res.data;
  },

  // Public listing of active plans
  getActive: async () => {
    const res = await publicApiClient.get('/SubscriptionPlans/active');
    return res.data;
  },

  // Bulk create (if needed by admin tooling)
  bulkCreate: async (payloadArray) => {
    const res = await publicApiClient.post('/SubscriptionPlans/bulk', payloadArray);
    return res.data;
  }
};

export { subscriptionPlanService };
export default subscriptionPlanService;
